import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import Navigation from '../../public/navigation';
import { Spin, Card, Icon, Button, Input, message } from 'antd';
import Editor from 'for-editor';
import { findReadme } from '../../../api/list';
import FormList from '../FormList';
import Comments from '../Comments';
import ItemInfo from '../ItemInfo';
import _util from '../../../util/index';
import { isEmpty } from 'lodash';
import classNames from 'classnames';

const { TextArea } = Input;

const { getStringByLength, getStringLength, getMiddleUrl } = _util;

const store = [
  'workflowStore',
  'homeStore',
]

const commentLength = 5000;

@inject(...store)
@observer
export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      markdownValue: '',
      markdownLoading: false,
      unfold: true,
    }
  }

  componentDidMount() {
    const { homeStore: { setType, type }, location: {pathname, query} } = this.props;
    document.documentElement.scrollTo({top: 0});
    setType('workflowChart', '流程表单');
    const appId = pathname.split('/').reverse()[0];
    const demoId = query.demoId;
    this.detail(appId, demoId, true);
  }

  componentWillReceiveProps(nextProps) {
    const { location: {pathname, query} } = nextProps;
    const _appId = pathname.split('/').reverse()[0];
    const appId = this.props.location.pathname.split('/').reverse()[0];
    if(appId !== _appId) {
      this.detail(_appId, query.demoId, true);
    }
  }

  componentWillUnmount() {
    const { workflowStore: { setState, initComment } } = this.props;
    setState({workflowDetail: {}});
    initComment();
  }
  
  detail = (appId, demoId, detailLoading) => {
    const { workflowStore: { getCommentList, getHotList, getDetail } } = this.props;
    this.findReadme(appId);
    getDetail({demoId, appId}, detailLoading);
    getCommentList({appId});
    getHotList();
  }

  onFormListClick = value => {
    const { workflowStore: { routing, setState, initComment }, location: { pathname } } = this.props;
    const { folderId, id } = value;
    const thisID = pathname.split('/').reverse()[0];
    routing.push({
      pathname: `/app/workflowDetail/${folderId}`,
      query: {
        demoId: id,
      }
    });
    if(thisID !== folderId) {
      setState({workflowDetail: value});
      initComment();
    }
  }

  getNumUnits = num => num < 1000 ? num : `${(num / 1000).toFixed(1)}k`;

  findReadme = async (appId) => {
    this.setState({markdownLoading: true})
    const res = await findReadme({
      appId,
    });
    this.setState({markdownLoading: false})
    try {
      if (res.status) {
        this.setState({ markdownValue: res.readme });
      } else {
        console.error('后端接口异常，请联系管理员！');
      }
    } catch (e) {
      console.error('接口错误：', e);
    }
  }

  onNavClick = (item) => {
    const { workflowStore: { routing }, location: { query } } = this.props;
    routing.push({
      pathname: item.path,
      query,
    });
  }

  submitComment = () => {
    const { workflowStore: { commentValue, addComment } } = this.props;
    const appId = this.props.location.pathname.split('/').reverse()[0];
    const value = commentValue.trim();
    if(value !== '') {
      addComment({
        appId,
        content: value,
      })
    } else {
      message.info("评论内容不能为空");
    }
  }

  onChange = e => {
    const { workflowStore: { setState } } = this.props;
    let value = e.target.value;
    if(getStringLength(value) > commentLength) {
      value = getStringByLength(value, commentLength);
    }
    setState({commentValue: value});
  }

  goBack = () => {
    const { workflowStore: { routing }, location: { query } } = this.props;
    const { demoId, ...otherQuery } = query;
    routing.push({
      pathname: '/app/workflow',
      query: otherQuery,
    });
  }

  render() {
    const { unfold } = this.state;
    const navs = [
      { key: '1', breadcrumbName: '云商店', path: '/' },
      { key: '2', breadcrumbName: '流程表单', path: '/app/workflow' },
      { key: '3', breadcrumbName: '详情', path: '/app/workflowDetail' },
    ];
    // const { markdownValue, markdownLoading } = this.state;
    const { workflowStore: { workflowDetail, relevant, downloadList, newComment, commentValue, commentParams, commentCount, detailLoading, setState, getCommentList }, location: { pathname, query } } = this.props;
    const appId = pathname.split('/').reverse()[0];
    const demoId = query.demoId;
    const data = workflowDetail;
    const tagTypeList = data && data.tagTypeList ? data.tagTypeList : [];
    const { nextNode = {}, prevNode = {} } = relevant;
    const leftClassName = classNames({
      'workflow-detail-body-left': true,
      'workflow-detail-body-left-unfold': !unfold,
    });
    const rightClassName = classNames({
      'workflow-detail-body-right': true,
      'workflow-detail-body-right-unfold': !unfold,
    });
    if(!data || !data.folderId) return <Spin spinning={detailLoading}><div style={{ width: '100%', height: 500 }} /></Spin>;
    const middleUrl = getMiddleUrl();
    return (
      <div className='workflow-detail'>
        <div className='workflow-detail-top'>
          <Navigation datas={navs} onClick={this.onNavClick} />
          <div className='workflow-detail-top-switch'>
            <span 
              className={`switch-button ${isEmpty(prevNode) && 'switch-disable'}`}
              onClick={() => !isEmpty(prevNode) && this.onFormListClick(prevNode)}
            >
              上一个<Icon type="left" />
            </span>
            <span
              className={`switch-button ${isEmpty(nextNode) && 'switch-disable'}`}
              onClick={() => !isEmpty(nextNode) && this.onFormListClick(nextNode)}
            >
              <Icon type="right" />下一个
            </span>
            <Button type="primary" className="switch-go-back" onClick={this.goBack}>返回</Button>
          </div>
        </div>
        <div className='workflow-detail-body'>
          <div className={leftClassName}>
            <h1 className="workflow-detail-body-left-title">{data.title}</h1>
            <Card
              className="workflow-detail-body-left-card"
              title="基本信息"
            >
              <Spin spinning={detailLoading}>
              {
                !detailLoading ? <div>
                  <p className="workflow-description">{data.description}</p>
                  <ItemInfo item={data} params={{appId, demoId}} detail>
                    <div className="workflow-info-box">
                      <span className="workflow-info-box-item workflow-tags">表单标签：
                        {
                          tagTypeList.map((tag) => 
                            <span key={tag.id} className="workflow-info-box-light workflow-tag">{tag.typeName}</span>
                          )
                        }
                      </span>
                    </div>
                  </ItemInfo>
                </div>
                : <div style={{height: 167}}/>
              }
              </Spin>
            </Card>
            <Card
              className="workflow-detail-body-left-card"
              title="相关表单"
            >
              <FormList datas={downloadList} className="related-form" onClick={this.onFormListClick}/>
            </Card>
            <Card
              className="workflow-detail-body-left-card"
              title="最新评论"
            >
              <div className="comment-input-box">
                <TextArea
                  placeholder="请输入评论内容"
                  autosize={{ minRows: 4, maxRows: 4 }}
                  value={commentValue}
                  onChange={this.onChange}
                />
                <Button type="primary" onClick={this.submitComment}>评论</Button>
              </div>
              <Comments
                datas={newComment}
                page={{
                  pageSize: commentParams.pageSize,
                  pageNum: commentParams.pageNum,
                  count: commentCount,
                  onChange: (pageNum, pageSize) => {
                    setState({commentParams: { ...commentParams, pageNum: pageNum }});
                    getCommentList({appId});
                  }
                }}
              />
            </Card>
          </div>
          <div className={rightClassName}>
            {
              data.attr && data.attr.previewUrl ? 
                <iframe name="workflowDetail" scrolling="no" className="workflow-detail-body-right-iframe" src={`${data.attr.previewUrl}&ecodessoid=test&csPreview=y`} />
                : <Spin spinning={detailLoading} >
                    {
                      !detailLoading ?
                      <div className="workflow-detail-body-right-notdata" >
                        <svg className="icon-font sort-btn-icon" aria-hidden="true">
                          <use href="#icon-cry"></use>
                        </svg>
                        <span >
                          未设置预览地址，请联系运营专员设置预览地址!
                        </span>
                      </div> : <div style={{height: 500}}/>
                    }
                  </Spin>
            }
            <div className="workflow-detail-unfold-button" onClick={() => this.setState({unfold: !unfold})}>
              <Icon type="right" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/workflow/detail/index.js